import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

/*UI Components*/
import ToggleButton from "primevue/togglebutton";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Tooltip from "primevue/tooltip";
import Maska from "maska";
import ConfirmDialog from "primevue/confirmdialog";
import PanelMenu from "primevue/panelmenu";
import Dropdown from "primevue/dropdown";
import Toast from "primevue/toast";
import Button from "primevue/button";
import Menu from "primevue/menu";
import Divider from "primevue/divider";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dialog from "primevue/dialog";
import Sidebar from "primevue/sidebar";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Card from "primevue/card";
import ProgressSpinner from "primevue/progressspinner";
import Breadcrumb from "primevue/breadcrumb";
import TieredMenu from "primevue/tieredmenu";
import TabMenu from "primevue/tabmenu";
import Checkbox from "primevue/checkbox";
import Calendar from "primevue/calendar";
import Skeleton from "primevue/skeleton";
import FileUpload from "primevue/fileupload";
import RadioButton from "primevue/radiobutton";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import InputMask from "primevue/inputmask";
import InputSwitch from "primevue/inputswitch";
import InputNumber from "primevue/inputnumber";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";

/*CSS*/
import "primevue/resources/themes/mdc-light-indigo/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import "./assets/normalize.css";
import "./assets/main.scss";

const app = createApp(App);
app.use(PrimeVue, {
    locale: {
        dayNames: [
            "Воскресенье",
            "Понедельник",
            "Вторник",
            "Среда",
            "Четверг",
            "Пятница",
            "Суббота",
        ],
        dayNamesShort: ["Воскр", "Пон", "Втор", "Ср", "Чет", "Пят", "Суб"],
        dayNamesMin: ["Вскр", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        monthNames: [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь",
        ],
        monthNamesShort: [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь",
        ],
        dateFormat: "dd.mm.yy",
        firstDayOfWeek: 1,
        passwordPrompt: "Введите пароль",
        emptyFilterMessage: "Результат не найден",
        emptyMessage: "Нет доступных опций",
        accept: "Да",
        reject: "Нет",
        choose: "Выбрать",
        upload: "Загрузить",
        cancel: "Отменить",
    },
});

app.component("DataTableItem", DataTable);
app.component("ColumnItem", Column);
app.component("ButtonItem", Button);
app.component("ToastItem", Toast);
app.component("DropdownItem", Dropdown);
app.component("PanelMenu", PanelMenu);
app.component("MenuItem", Menu);
app.component("DialogItem", Dialog);
app.component("SidebarItem", Sidebar);
app.component("InputText", InputText);
app.component("PasswordItem", Password);
app.component("CardItem", Card);
app.component("DividerItem", Divider);
app.component("ProgressSpinnerItem", ProgressSpinner);
app.component("BreadcrumbItem", Breadcrumb);
app.component("TieredMenuItem", TieredMenu);
app.component("TabMenuItem", TabMenu);
app.component("CheckboxItem", Checkbox);
app.component("CalendarItem", Calendar);
app.component("SkeletonItem", Skeleton);
app.component("ConfirmDialog", ConfirmDialog);
app.component("AccordionItem", Accordion);
app.component("AccordionTabItem", AccordionTab);
app.component("InputMaskItem", InputMask);
app.component("FileUploadItem", FileUpload);
app.component("RadioButtonItem", RadioButton);
app.component("InputSwitchItem", InputSwitch);
app.component("InputNumber", InputNumber);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("ToggleButton", ToggleButton);

app.directive("tooltip", Tooltip);

app.use(store)
    .use(router)
    .use(ToastService)
    .use(Maska)
    .use(ConfirmationService)
    .mount("#app");
